export const GIFT_PLAN_SELECT_KEY = 'giftPlanSelect'

export default GIFT_PLAN_SELECT_KEY
